export default __webpack_public_path__ + "img/secondary_feedsupport.png";